import Dropdown from './Dropdown'

Vue.component(Dropdown.name, Dropdown)
